import React from 'react';
import { Box, Typography } from '@mui/material';
import { CurrencyInput, useFormContext, BELARUS, POLAND, formatCurrencyValue } from 'framework/form';
import { COMPETENCY_LEVEL_WITHOUT_NA } from '../../vacancy/shared/vacancyService';

const SalaryForkLevelsForm = () => {
  const { data } = useFormContext();
  const { country } = data || {};

  return (
    <Box
      sx={(theme: any) => ({
        display: 'flex',
        maxWidth: '800px',
        flexWrap: 'wrap',
        columnGap: '46px',
        [theme.breakpoints.down('sm')]: {
          maxWidth: '100%',
        },
        '.floating-label-baseInput': {
          mb: '0px !important',
        },
      })}
    >
      {(Object.values(COMPETENCY_LEVEL_WITHOUT_NA) as Array<keyof typeof COMPETENCY_LEVEL_WITHOUT_NA>).map(level => (
        <Box
          key={level}
          sx={{
            display: 'flex',
            alignItems: 'flex-starts',
            mb: '25px',
          }}
        >
          {/* Level Label */}
          <Box sx={{ width: '45px' }}>
            <Typography variant="h6" color="primary" sx={{ textTransform: 'uppercase' }}>
              {level}
            </Typography>
          </Box>

          {/* BY Section */}
          {country === BELARUS.code ? (
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
              <Box sx={{ width: '120px' }}>
                <CurrencyInput
                  maxDecimal={0}
                  allowDecimal={false}
                  formatInitialValue={formatCurrencyValue}
                  source={`${level}.bySalaryFromValue`}
                  placeholder=""
                  label="min"
                  sx={{ mb: '0px !important' }}
                />
              </Box>
              <Typography>—</Typography>
              <Box sx={{ width: '120px' }}>
                <CurrencyInput
                  maxDecimal={0}
                  allowDecimal={false}
                  formatInitialValue={formatCurrencyValue}
                  source={`${level}.bySalaryToValue`}
                  placeholder=""
                  label="max"
                  sx={{ mb: '0px !important' }}
                />
              </Box>
            </Box>
          ) : null}

          {/* PL Section */}
          {country === POLAND.code ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{ width: '120px' }}>
                <CurrencyInput
                  maxDecimal={0}
                  allowDecimal={false}
                  formatInitialValue={formatCurrencyValue}
                  source={`${level}.plSalaryFromValue`}
                  placeholder=""
                  label="min"
                  sx={{ mb: '0px !important' }}
                />
              </Box>
              <Typography>—</Typography>
              <Box sx={{ width: '120px' }}>
                <CurrencyInput
                  maxDecimal={0}
                  allowDecimal={false}
                  formatInitialValue={formatCurrencyValue}
                  source={`${level}.plSalaryToValue`}
                  placeholder=""
                  label="max"
                  sx={{ mb: '0px !important' }}
                />
              </Box>
            </Box>
          ) : null}
        </Box>
      ))}
    </Box>
  );
};

export default SalaryForkLevelsForm;
